/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useConditionFieldSelect } from '../../hooks/useConditionFieldSelect';
import EditorConditionFieldOptions from './EditorConditionFieldOptions';
import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import EditorFixedHeaderContainer from './EditorFixedHeaderContainer';
import EditorTitleHeader from './EditorTitleHeader';
import EditorFilterSelectNav from './EditorFilterSelectNav';
import EditorObjectTypeSelect from './EditorObjectTypeSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EditorConditionFieldSelect = ({
  filterFamily
}) => {
  const {
    filterFamilyName,
    inputRef,
    isLoadingFields,
    onSearchChange,
    searchString
  } = useConditionFieldSelect(filterFamily);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(EditorFixedHeaderContainer, {
      children: [/*#__PURE__*/_jsx(EditorTitleHeader, {}), /*#__PURE__*/_jsx(EditorObjectTypeSelect, {}), /*#__PURE__*/_jsx(EditorFilterSelectNav, {}), /*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputAreaLabel'),
        children: /*#__PURE__*/_jsx(SearchInput, {
          "data-onboarding": "search-properties-input-field",
          "data-selenium-test": "fr-filter-search-input",
          inputRef: inputRef,
          onChange: onSearchChange,
          placeholder: I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputPlaceholder', {
            filterFamilyLabel: filterFamilyName.toLowerCase()
          })
        })
      })]
    }), /*#__PURE__*/_jsx(EditorConditionFieldOptions, {
      filterFamily: filterFamily,
      isLoadingFields: isLoadingFields,
      searchString: searchString
    })]
  });
};
export default EditorConditionFieldSelect;